module.exports = __webpack_public_path__ + "media/hero_decorative-celebration-01.fa5a3afc.wav";